import React, { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { buildOnboardingRedirectUrl } from 'redux/Reducers/Onboarding/OnboardingSlice';

import 'Assets/styles/default/components/Onboarding/OnboardingRedirectModal/OnboardingRedirectModal.less'

import {
  Col,
  Divider,
  Row,
  Space,
  VertButton,
  VertContainer,
  VertModal,
  VertTypography,
} from '@vertem-core/vertice-ds';

const OnboardingRedirectModal = (props) => {
  const { open, handleClose } = props;

  const dispatch = useDispatch();

  const { onboardingRedirectUrl } = useSelector(({ Onboarding }) => Onboarding);

  useEffect(() => {
    dispatch(buildOnboardingRedirectUrl());
  }, []);

  return (
    <VertModal
      className='onboarding-redirect-modal'
      open={open}
      onCancel={() => handleClose()}
      width={540}
      closable={false}
      maskClosable={false}
      keyboard={false}
    >
      <VertContainer spacingX='regular'>
        <Space direction='vertical'>
          <VertTypography.Paragraph style={{ width: '100%' }} strong type='detached' align='center'>
            Verificação de Segurança - Autenticação em Duas Etapas
          </VertTypography.Paragraph>
          <section className='modal-content-onboarding' style={{ width: '100%' }}>
            <VertTypography.Paragraph type='light' align='center'>
              Para efetuar seu resgate você deve realizar a verificação em duas etapas.
              Caso contrário não será possível resgatar.
            </VertTypography.Paragraph>
          </section>
        </Space>

      <Divider />

        <Row justify='center'>
          <Col className='action-btn-group'>

            <VertButton type='highlight'>
              <a href={onboardingRedirectUrl} target="_blank" rel="noopener noreferrer">
                Continuar
              </a>
            </VertButton>
          </Col>
        </Row>
      </VertContainer>
    </VertModal>
  );
}

export default OnboardingRedirectModal;
